import classnames from 'classnames';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { pickContextTypes } from '../../context-types';

import styles from './time.styl';


@WixConnect(styles)
export default class Time extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
  };

  static contextTypes = pickContextTypes('currentTime', 'duration', 'fullScreen');

  formatTime(seconds) {
    const date = new Date(null);
    seconds = isNaN(seconds) || !isFinite(seconds) ? 0 : Math.floor(seconds);
    date.setSeconds(seconds);

    // get HH:mm:ss part, remove hours if they are "00:"
    return date
      .toISOString()
      .substr(11, 8)
      .replace(/^00:/, '');
  }

  render() {
    const { className } = this.props;
    const { currentTime, duration, fullScreen } = this.context;
    const styleNames = classnames('time', {
      'at-full-screen': fullScreen,
    });

    return (
      <div styleName={styleNames}
           className={className}>
        <span styleName="time__current">
          {this.formatTime(currentTime)}
        </span>
        /
        <span styleName="time__duration">
          {this.formatTime(duration)}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/controls/time/time.js